import React, { useState, useCallback, useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import ThumbsUpIcon from 'mdi-react/ThumbsUpIcon';
import ThumbsUpOutlineIcon from 'mdi-react/ThumbsUpOutlineIcon';
import LoginPromoModal from '../../../modal/login-promo';

import * as S from './styles';

import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated';

import { UserReview } from '../../../../types';

type Props = {
  className?: string;
  onClick: () => void;
  liked: boolean;
  likes: UserReview['likeScore'];
  size?: number;
  text?: string;
};

const HelpfulButton = ({
  className,
  onClick,
  liked,
  likes,
  size = 20,
  text,
}: Props) => {
  const { t } = useContext(AppContext);
  const [likeScore, setLikeScore] = useState(likes);
  const isAuthenticated = useIsAuthenticated();
  const [showLoginPromo, setShowLoginPromo] = useState(false);

  const handler = useCallback(() => {
    if (!isAuthenticated) {
      setShowLoginPromo(true);
      return;
    }

    onClick();

    // Fake a +1 in like score as the real data is not updated in real time
    if (!liked) {
      setLikeScore((likes || 0) + 1);
    }
  }, [onClick, likes, liked, isAuthenticated]);

  const hideLoginPromo = useCallback(() => {
    setShowLoginPromo(false);
  }, []);

  return (
    <>
      {showLoginPromo ? (
        <LoginPromoModal isOpen onRequestClose={hideLoginPromo} />
      ) : null}

      <S.HelpfulButton onClick={handler} liked={liked} className={className}>
        <S.HelpfulText>{text || t('reviews', 'button.helpful')}</S.HelpfulText>

        {liked ? (
          <>
            <ThumbsUpIcon size={size} /> <S.Count>{likeScore || 1}</S.Count>
          </>
        ) : (
          <>
            <ThumbsUpOutlineIcon size={size} />{' '}
            <S.Count>{likes || null}</S.Count>
          </>
        )}
      </S.HelpfulButton>
    </>
  );
};

export default HelpfulButton;
